import { useSettings, buildWhatsAppUrl } from "@/lib/useSettings";
import Icon from "@/components/Icon";

export default function WhatsAppFloating() {
  const { settings } = useSettings();
  if (!settings?.whatsapp) return null;
  const href = buildWhatsAppUrl(settings.whatsapp, settings.whatsapp_prefill_ar);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="aman-whatsapp"
      aria-label="تواصل معنا على واتساب"
      data-testid="whatsapp-floating"
    >
      {/* WhatsApp glyph */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="28"
        height="28"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M20.52 3.48A11.87 11.87 0 0012.03 0C5.4 0 .05 5.35.05 11.97a11.9 11.9 0 001.63 6.02L0 24l6.18-1.63a12 12 0 005.85 1.5h.01c6.62 0 11.97-5.35 11.97-11.97a11.9 11.9 0 00-3.49-8.42zM12.04 21.9h-.01a10 10 0 01-5.09-1.4l-.36-.22-3.66.96.98-3.57-.24-.37a9.94 9.94 0 01-1.55-5.33c0-5.5 4.48-9.97 9.99-9.97 2.66 0 5.17 1.04 7.05 2.92a9.9 9.9 0 012.92 7.06c0 5.5-4.48 9.92-9.99 9.92zm5.47-7.46c-.3-.15-1.77-.87-2.04-.97s-.47-.15-.67.15c-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.49 1.06 2.89 1.21 3.09c.15.2 2.1 3.2 5.09 4.49.71.31 1.26.5 1.69.64.71.23 1.36.2 1.87.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.08-.13-.27-.2-.57-.35z" />
      </svg>
    </a>
  );
}
